import * as React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';

import { ScrollBar } from './scroll-bar';
import { useScroll } from 'ahooks';
import { useRef } from 'react';
import { _scrollBarVariant } from './scroll-bar';
import { VariantProps } from 'class-variance-authority';

interface ScrollAreaProps extends VariantProps<typeof _scrollBarVariant> {
    onCustomScroll?: (val: {
        left: number;
        right: number;
        top: number;
        bottom: number;
    }) => void;
}

export const ScrollArea = React.forwardRef<
    React.ElementRef<typeof ScrollAreaPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> &
        ScrollAreaProps
>(({ children, onCustomScroll, scrollBarVisibility, ...props }, ref) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    useScroll(scrollRef, val => {
        if (onCustomScroll && scrollRef?.current && val) {
            onCustomScroll({
                left: val.left,
                right:
                    scrollRef?.current.scrollWidth -
                    val.left -
                    scrollRef?.current.offsetWidth,
                top: val.top,
                bottom:
                    scrollRef?.current.scrollHeight -
                    val.top -
                    scrollRef?.current.offsetHeight,
            });
        }

        return true;
    });

    return (
        <ScrollAreaPrimitive.Root
            ref={ref}
            className="relative overflow-hidden"
            {...props}
        >
            <ScrollAreaPrimitive.Viewport
                className="h-full w-full rounded-[inherit]"
                ref={scrollRef}
            >
                {children}
            </ScrollAreaPrimitive.Viewport>
            <ScrollBar scrollBarVisibility={scrollBarVisibility} />
            <ScrollAreaPrimitive.Corner />
        </ScrollAreaPrimitive.Root>
    );
});

ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
